'use strict';

/**
 * Pict-Provider-LinkAPI
 * ---------------------
 * Browser-side client for the thin join tables (FeatureVisionJoin,
 * FeatureModuleJoin, VisionVisionJoin). The EntityDetail view uses it to read
 * the links for one parent record and to add / remove links. Tenancy is
 * enforced server-side (IDCustomer is stamped on create and filters reads), so
 * the client only sends the two FK columns (and RelationType where relevant).
 *
 * No AppData of its own — links are transient, read per-parent on demand and
 * re-read after a mutation.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'LinkAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderLinkAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	/**
	 * Read the join rows for one parent: GET /1.0/<Plural>/FilteredTo/<Field>=<Value>/0/250
	 */
	listLinks(pPlural, pField, pValue)
	{
		// meadow-filter DSL: INSTRUCTION~FIELD~OPERATOR~VALUE (FBV = Filter By
		// Value, EQ = equals). NOT "Field=Value" — that parses to <4 terms and
		// is silently ignored (returns the whole tenant set).
		let tmpURL = pPlural + '/FilteredTo/FBV~' + pField + '~EQ~' + pValue + '/0/250';
		return libFrameworkClient.getJSON(this.fable, this._url(tmpURL))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	/**
	 * Multi-condition filtered read: each entry adds an FBV~Field~EQ~Value term
	 * (chained by ~ for AND). e.g. listLinksWhere('DocEntityLinks',
	 * [{Field:'EntityType',Value:'Vision'},{Field:'IDEntity',Value:3}]).
	 */
	listLinksWhere(pPlural, pFilters)
	{
		let tmpFilter = (pFilters || []).map((pF) => 'FBV~' + pF.Field + '~EQ~' + pF.Value).join('~');
		let tmpURL = pPlural + '/FilteredTo/' + tmpFilter + '/0/250';
		return libFrameworkClient.getJSON(this.fable, this._url(tmpURL))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}

	addLink(pEntity, pRecord)
	{
		return libFrameworkClient.postJSON(this.fable, this._url(pEntity), pRecord);
	}

	removeLink(pEntity, pID)
	{
		return libFrameworkClient.delJSON(this.fable, this._url(pEntity + '/' + pID))
			.then(() => true);
	}
}

module.exports = PictProviderLinkAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
